import { Box, Skeleton, Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useQuery } from 'urql'
import { NotFound } from '../components/NotFound'
import PageHeader from '../components/PageHeader'
import { graphql } from '../gql'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

export default function VendorPage() {
  const setDocumentTitle = useDocumentTitle('Vendor')
  const params = useParams<{ vendorId: string }>()
  if (!params.vendorId) {
    throw new Error('Vendor ID is required')
  }
  const vendorId = Number.parseInt(params.vendorId, 10)
  const [pageQueryResult] = useQuery({
    query: graphql(/* GraphQL */ `
      query VendorPage($id: Int!) {
        Vendor(id: $id) {
          name
        }
      }
    `),
    variables: { id: vendorId },
  })

  const vendor = pageQueryResult.data?.Vendor

  useEffect(() => {
    if (vendor) {
      setDocumentTitle(vendor.name)
    }
  }, [vendor, setDocumentTitle])

  if (pageQueryResult.fetching) {
    return (
      <Box display="flex" flexDirection="column" flex="1">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Skeleton variant="text" width="200px" height="32px" />
        </Stack>
      </Box>
    )
  }
  if (pageQueryResult.error) {
    if (pageQueryResult.error.message?.toLowerCase().includes('not found')) {
      return <NotFound title="Vendor not found" />
    }
    return <Typography>Error loading vendor</Typography>
  }
  if (!vendor) {
    return <NotFound />
  }
  return (
    <Box display="flex" flexDirection="column" flex="1">
      <PageHeader title={vendor.name} />
      <Typography>
        This is a placeholder for the vendor page. In the future, this page will display statistics about the vendor
        (cumulative commission paid, outstanding projects, etc).
      </Typography>
    </Box>
  )
}
